import { render } from "./BuscarFavoritosClientePage.vue?vue&type=template&id=a0590488&scoped=true"
import script from "./BuscarFavoritosClientePage.vue?vue&type=script&lang=js"
export * from "./BuscarFavoritosClientePage.vue?vue&type=script&lang=js"

import "./BuscarFavoritosClientePage.vue?vue&type=style&index=0&id=a0590488&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0590488"]])

export default __exports__